exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".warning1 {\r\n    font-size: 20px;\r\n  }\r\n\r\n.warning2 {\r\n  font-size: 13px;\r\n  font-family: sans-serif;\r\n}\r\n\r\n.buttonCont {\r\n    text-align: right\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Elise/essaiGit3/Converteo-Referentiel-RH/public/src/app/profile/delete-form/delete-form.component.css
// module id = ../../../../../src/app/profile/delete-form/delete-form.component.css
// module chunks = main